module.exports = ".gst-service p{\r\n    font-size: 15px;\r\n  }\r\n  \r\n  .article-png{\r\n    text-align: center;\r\n    margin-left: 100px;\r\n    margin-top: 30px;\r\n    margin-bottom: 30px;\r\n  }\r\n  \r\n  .subheading{\r\n    margin-top: 25px;\r\n    font-size: 17px;\r\n    color: #16A085;\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/d2z/views/policy/policy.component.css
// module id = ./src/app/d2z/views/policy/policy.component.css
// module chunks = main